<!--
 * @Author: Nemo
 * @Description: OnDialog组件 - PC端实现
 * @Date: 2025-11-19
-->
<template>
  <div v-if="visible || closing" class="on-dialog">
    <!-- 弹窗蒙层 -->
    <div class="on-dialog-mask" @click="handleMaskClick" :class="{ 'mask-fade-out': closing }" />

    <!-- PC端对话框 -->
    <div class="on-dialog-container pc-dialog" :class="{ 'fade-out': closing }">
      <div class="dialog-header">
        <div class="dialog-title">{{ title }}</div>
        <div class="dialog-close" @click="handleClose">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="dialog-content">
        <slot></slot>
      </div>
      <div class="dialog-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
      <div class="dialog-footer" v-else-if="showDefaultFooter">
        <on-button class="dialog-cancel-btn" plain @click="handleCancel">
          {{ cancelText }}
        </on-button>
        <on-button class="dialog-confirm-btn" @click="handleConfirm">
          {{ confirmText }}
        </on-button>
      </div>
    </div>
  </div>
</template>

<script>
import OnButton from '../button/index.vue';

export default {
  name: 'OnDialogPC',
  components: {
    OnButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    closeOnClickMask: {
      type: Boolean,
      default: true,
    },
    showDefaultFooter: {
      type: Boolean,
      default: true,
    },
    confirmText: {
      type: String,
      default: '确认',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
  },
  data() {
    return {
      closing: false,
    };
  },
  mounted() {
    if (this.visible) {
      document.body.style.overflow = 'hidden';
    }
  },
  watch: {
    visible(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = '';
      }
    },
  },
  beforeDestroy() {
    document.body.style.overflow = '';
  },
  methods: {
    /**
     * 关闭弹窗
     * @author Nemo
     */
    handleClose() {
      this.closing = true;
      setTimeout(() => {
        this.closing = false;
        this.$emit('update:visible', false);
        this.$emit('close');
        document.body.style.overflow = '';
      }, 300);
    },

    /**
     * 点击蒙层
     * @author Nemo
     */
    handleMaskClick() {
      if (this.closeOnClickMask) {
        this.handleClose();
      }
    },

    /**
     * 确认按钮
     * @author Nemo
     */
    handleConfirm() {
      this.$emit('confirm');
    },

    /**
     * 取消按钮
     * @author Nemo
     */
    handleCancel() {
      this.$emit('cancel');
      this.handleClose();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 蒙层样式 */
.on-dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  backdrop-filter: blur(4px);
  transition: opacity 0.3s ease;

  &.mask-fade-out {
    opacity: 0;
  }
}

/* 容器样式 */
.on-dialog-container {
  position: fixed;
  z-index: 2001;
  background: #FFFFFF;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

/* PC端样式 */
.pc-dialog {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 420px;
  max-width: 600px;
  border-radius: 8px;

  &.fade-out {
    opacity: 0;
    transform: translate(-50%, -40%);
  }
}

.pc-dialog .dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
}

.pc-dialog .dialog-title {
  font-weight: 600;
  font-size: 20px;
  color: #1A202C;
}

.pc-dialog .dialog-close {
  cursor: pointer;
  color: #8D98AF;
  font-size: 20px;
  line-height: 1;
}

.pc-dialog .dialog-close:hover {
  color: #182058;
}

.pc-dialog .dialog-content {
  padding: 0 24px;
  font-size: 14px;
  color: #667085;
  line-height: 20px;
  margin-bottom: 8px;
}

.pc-dialog .dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
}

.pc-dialog .dialog-cancel-btn,
.pc-dialog .dialog-confirm-btn {
  width: auto;
  min-width: 100px;
}
</style>
